import { render, staticRenderFns } from "./privacy-policies-tab.vue?vue&type=template&id=04a5f608"
import script from "./privacy-policies-tab.vue?vue&type=script&lang=js"
export * from "./privacy-policies-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports